import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	header: {
		padding: "30px 32px 0",
		position: "relative"
	},
	title: {
		color: themeColors.colors.system.gray[900],
		fontSize: "24px",
		fontWeight: 500,
		lineHeight: 1.3,
		letterSpacing: "-0.015em"
	},
	subtitle: {
		marginTop: 10,
		color: themeColors.colors.system.gray[600],
		fontSize: "14.5px",
		fontWeight: 400,
		lineHeight: 1.6
	},
	linkContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 12,
		margin: "20px 32px 0",
		backgroundColor: themeColors.colors.system.gray[50],
		border: `1px solid ${themeColors.colors.system.gray[100]}`,
		borderRadius: 12,
		padding: "14px 16px"
	},
	linkText: {
		flex: 1,
		color: themeColors.colors.system.gray[900],
		fontSize: "14.5px",
		fontWeight: 400,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	copyButton: {
		padding: "6px 16px",
		borderRadius: 8,
		border: "none",
		backgroundColor: themeColors.colors.system.purple[50],
		color: themeColors.colors.system.gray[900],
		fontSize: "13px",
		fontWeight: 600,
		cursor: "pointer",
		whiteSpace: "nowrap",
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: themeColors.colors.system.purple[100]
		}
	},
	copyButtonCopied: {
		backgroundColor: themeColors.colors.success[50],
		color: themeColors.colors.success[600],
		"&:hover": {
			backgroundColor: themeColors.colors.success[50]
		}
	},
	footer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "20px 32px 26px",
		marginTop: "auto"
	},
	backLink: {
		background: "none",
		border: "none",
		color: themeColors.colors.system.gray[600],
		fontSize: "13px",
		fontWeight: 400,
		cursor: "pointer",
		padding: 0,
		transition: "color 0.2s ease",
		"&:hover": {
			color: themeColors.colors.system.gray[900]
		}
	},
	whatsappButton: {
		padding: "15px 24px",
		borderRadius: 12,
		border: "none",
		backgroundColor: themeColors.colors.success[600],
		color: themeColors.colors.system.gray[50],
		fontSize: "15.5px",
		fontWeight: 600,
		cursor: "pointer",
		boxShadow: "0 10px 22px rgba(31, 168, 90, 0.28)",
		whiteSpace: "nowrap",
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: themeColors.colors.success[700]
		}
	},
	whatsappButtonLabel: {
		display: "flex",
		alignItems: "center",
		gap: 8
	},
	whatsappIcon: {
		fontSize: 18
	}
}))

export default useStyles
